export function resizeVideoIframe({ $el, $iframe, player }) {
  return Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then((dimensions) => {
    const videoDimensions = [$el.width(), $el.height()];

    const vimeoRatio = dimensions[0] / dimensions[1];
    const videoRatio = videoDimensions[0] / videoDimensions[1];

    if (vimeoRatio > videoRatio) {
      $iframe.width(videoDimensions[1] * vimeoRatio)
        .height(videoDimensions[1]);
    } else {
      $iframe.width(videoDimensions[0])
        .height(videoDimensions[0] * videoRatio);
    }
  });
}
